export default function scrollToTop(element, data) {    
    element.querySelectorAll('.sticky__image').forEach((item, index) => {
        item.style.top = `${index * 20}px`;
    });
};
